const PRINTABLE_LABEL_TYPES = new Set(['application/pdf', 'image/png', 'image/jpeg']);
const THERMAL_LABEL_TYPES = new Map([
  ['application/zpl', 'application/zpl'],
  ['application/vnd.zebra-zpl', 'application/zpl'],
  ['application/epl', 'application/epl2'],
  ['application/epl2', 'application/epl2'],
]);

export function isThermalLabelContentType(contentType: string): boolean {
  const type = contentType.split(';', 1)[0].trim().toLowerCase();
  return THERMAL_LABEL_TYPES.has(type) || ['text/plain', 'application/octet-stream'].includes(type);
}

/** Resolve generic carrier responses using their bytes, never the file extension alone. */
export function resolveLabelContentType(contentType: string, bytes: Uint8Array, pathname = ''): string | null {
  const type = contentType.split(';', 1)[0].trim().toLowerCase();
  if (PRINTABLE_LABEL_TYPES.has(type)) return type;
  const thermalType = THERMAL_LABEL_TYPES.get(type);
  if (thermalType) return thermalType;
  // Explicit HTML, JSON, XML and other unsupported types remain rejected even
  // when the source URL or a caller's format hint claims to be a shipping label.
  if (type && !['text/plain', 'application/octet-stream'].includes(type)) return null;
  const startsWith = (signature: number[]) => signature.every((value, index) => bytes[index] === value);
  if (startsWith([0x25, 0x50, 0x44, 0x46, 0x2d])) return 'application/pdf';
  if (startsWith([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a])) return 'image/png';
  if (startsWith([0xff, 0xd8, 0xff])) return 'image/jpeg';
  // Printer-language files are download-only. Keep their format without ever
  // treating arbitrary text or a URL ending in .pdf/.png as browser content.
  if (pathname.toLowerCase().endsWith('.zpl')) return 'application/zpl';
  if (/\.epl2?$/i.test(pathname)) return 'application/epl2';
  return null;
}
